import { render, staticRenderFns } from "./CustomUniqueFields.vue?vue&type=template&id=2c261f5d"
import script from "./CustomUniqueFields.vue?vue&type=script&lang=js"
export * from "./CustomUniqueFields.vue?vue&type=script&lang=js"
import style0 from "./CustomUniqueFields.vue?vue&type=style&index=0&id=2c261f5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports